module.exports = __webpack_public_path__ + "img/ce4.c96499bc.png";